// extracted by mini-css-extract-plugin
export default {"uploadingJobs":"uploadingJobs---CG6GP"};